import {apiRequest} from "./apiRequest";
import type {Promotion, PromotionCreateRequest, PromotionUpdateRequest} from "../types/promotion";

export async function getPromotions(): Promise<Promotion[]> {
  return apiRequest<Promotion[]>({path: "admin/promotions"});
}

export async function createPromotion(body: PromotionCreateRequest): Promise<Promotion> {
  return apiRequest<Promotion>({
    path: "admin/promotions",
    method: "POST",
    body,
  });
}

export async function updatePromotion(id: string, body: PromotionUpdateRequest): Promise<Promotion> {
  return apiRequest<Promotion>({
    path: `admin/promotions/${id}`,
    method: "PUT",
    body: {...body, id},
  });
}

export async function deletePromotion(id: string): Promise<void> {
  return apiRequest<void>({
    path: `admin/promotions/${id}`,
    method: "DELETE",
  });
}
